import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { mergeStyles, isSSR } from 'wix-rich-content-common';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import DropdownArrowIcon from '../Icons/DropdownArrowIcon.js';

var css_248z = ".glob_fontElementMap,.mLHyB{font-family:var(--ricos-font-family,unset)}.P61D7{color:inherit;display:inline-block;height:19px;vertical-align:middle;width:19px}[dir=ltr] .P61D7{margin:-4px 12px 0 0}[dir=rtl] .P61D7{margin:-4px 0 0 12px}.iqq1p{color:inherit;display:inline-block;font-size:14px}.vzNMA{font-size:14px}.eoF9q,.vzNMA{color:var(--ricos-settings-text-color,#333);position:relative}.eoF9q{overflow:hidden;transition:all .2s ease;white-space:nowrap}[dir] .eoF9q{background-color:#fff;border:none;cursor:pointer}[dir=ltr] .eoF9q{padding:10px 62px 10px 0}[dir=rtl] .eoF9q{padding:10px 0 10px 62px}[dir] .eoF9q:hover{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}.eoF9q .PKHb-{color:var(--ricos-fallback-color,#000)}.oKFWT{display:block;height:19px;position:absolute;top:10px;width:19px}[dir=ltr] .oKFWT{right:6px}[dir=rtl] .oKFWT{left:6px}.oKFWT svg{fill:var(--ricos-settings-icons-color,#000);color:var(--ricos-settings-icons-color,#000)}[dir=ltr] ._4LdGD{transform:rotate(180deg)}[dir=rtl] ._4LdGD{transform:rotate(-180deg)}.NOrTi{-webkit-overflow-scrolling:touch;color:var(--ricos-settings-text-color,#333);font-family:var(--ricos-settings-text-font-family,HelveticaNeue,Helvetica,Arial);max-height:250px;overflow-y:auto;position:fixed;top:100%;width:auto;z-index:1000}[dir] .NOrTi{background-color:#fff;border:1px solid #ededed;border-radius:8px;margin-top:-2px;padding:8px 0}[dir=ltr] .NOrTi{margin-left:-10px}[dir=rtl] .NOrTi{margin-right:-10px}.-J1BG{color:var(--ricos-settings-text-color,#333);font-family:var(--ricos-settings-text-font-family,HelveticaNeue,Helvetica,Arial);font-weight:700;text-transform:capitalize}[dir] .-J1BG{padding:8px 10px}.-M-Jb{color:var(--ricos-settings-text-color,#333);display:block;white-space:nowrap}[dir] .-M-Jb{background-color:transparent;border:none;cursor:pointer;padding:0 12px}.-M-Jb .PKHb-{color:var(--ricos-settings-dividers-color,rgba(0,0,0,.314))}.-M-Jb:hover{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}.-M-Jb:hover svg{fill:var(--ricos-settings-icons-color,#000);color:var(--ricos-settings-icons-color,#000)}.gyZwG{color:rgba(17,34,51,.267)}[dir=ltr] .-M-Jb:last-child{border-bottom-left-radius:2px;border-bottom-right-radius:2px}[dir=rtl] .-M-Jb:last-child{border-bottom-left-radius:2px;border-bottom-right-radius:2px}.NVV-s{color:var(--ricos-settings-text-color,#333);display:block}[dir] .NVV-s{cursor:default;padding:8px 10px}";
var styles = {"fontElementMap":"mLHyB","Dropdown-option-icon":"P61D7","Dropdown-option-label":"iqq1p","Dropdown-root":"vzNMA","Dropdown-control":"eoF9q","divider":"PKHb-","Dropdown-arrow":"oKFWT","Dropdown-arrow-isOpen":"_4LdGD","Dropdown-menu":"NOrTi","Dropdown-title":"-J1BG","Dropdown-option":"-M-Jb","Dropdown-option-selected":"gyZwG","Dropdown-noresults":"NVV-s"};
styleInject(css_248z);

const DEFAULT_PLACEHOLDER_STRING = "Select...";
class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.handleMouseDown = (event) => {
      var _a, _b;
      if (this.props.onFocus && typeof this.props.onFocus === "function") {
        this.props.onFocus(this.state.isOpen);
      }
      if (event.type === "mousedown" && event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      if (!this.props.disabled) {
        this.setState({
          isOpen: !this.state.isOpen
        });
      }
      (_b = (_a = this.props).onClick) == null ? void 0 : _b.call(_a);
    };
    this.fireChangeEvent = (newState) => {
      if (newState.selected !== this.state.selected && this.props.onChange) {
        this.props.onChange(newState.selected);
      }
    };
    this.handleDocumentClick = (event) => {
      var _a;
      if (this.mounted) {
        if (!((_a = ReactDOM.findDOMNode(this)) == null ? void 0 : _a.contains(event.target))) {
          if (this.state.isOpen) {
            this.setState({ isOpen: false });
          }
        }
      }
    };
    this.state = {
      selected: this.getCurrentValue(props),
      isOpen: false
    };
    this.mounted = true;
    this.styles = mergeStyles({ styles, theme: props.theme });
    this.id = `cmbx_${Math.floor(Math.random() * 9999)}`;
  }
  componentWillReceiveProps(newProps) {
    this.setState({ selected: this.getCurrentValue(newProps) });
  }
  componentDidMount() {
    if (typeof document !== "undefined") {
      document.addEventListener("click", this.handleDocumentClick, false);
      document.addEventListener("touchend", this.handleDocumentClick, false);
    }
  }
  componentWillUnmount() {
    this.mounted = false;
    if (typeof document !== "undefined") {
      document.removeEventListener("click", this.handleDocumentClick, false);
      document.removeEventListener("touchend", this.handleDocumentClick, false);
    }
  }
  getCurrentValue(props) {
    if (typeof props.value !== "undefined") {
      return props.value;
    } else if (typeof props.getValue === "function") {
      return props.getValue();
    } else {
      return {
        label: props.placeholder || DEFAULT_PLACEHOLDER_STRING,
        value: ""
      };
    }
  }
  setValue(value, label, component) {
    const newState = {
      selected: {
        value,
        label,
        component
      },
      isOpen: false
    };
    this.fireChangeEvent(newState);
    this.setState(newState);
  }
  renderOption(option) {
    const { styles: styles2 } = this;
    const optionClass = classNames({
      [styles2["Dropdown-option"]]: true,
      [styles2["Dropdown-option-selected"]]: option === this.state.selected
    });
    const { value, label, icon: Icon, component: OptionComponent } = option;
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: value,
        className: optionClass,
        "data-hook": `${label || value}_dropdown_option`,
        onClick: this.setValue.bind(this, value, label, OptionComponent),
        role: "option",
        "aria-selected": option === this.state.selected,
        "aria-label": label
      },
      Icon && /* @__PURE__ */ React.createElement(Icon, { className: styles2["Dropdown-option-icon"] }),
      label && /* @__PURE__ */ React.createElement("span", { className: styles2["Dropdown-option-label"] }, label),
      OptionComponent && /* @__PURE__ */ React.createElement(OptionComponent, null)
    );
  }
  buildMenu() {
    const { options } = this.props;
    const ops = options.map((option) => {
      var _a;
      if (option.type === "group") {
        const groupTitle = /* @__PURE__ */ React.createElement("div", { className: styles["Dropdown-title"] }, option.name);
        const _options = (_a = option.items) == null ? void 0 : _a.map((item) => this.renderOption(item));
        return /* @__PURE__ */ React.createElement("div", { className: styles["Dropdown-group"], key: option.name }, groupTitle, _options);
      } else {
        return this.renderOption(option);
      }
    });
    return ops.length ? ops : /* @__PURE__ */ React.createElement("div", { className: styles["Dropdown-noresults"] }, "No options found");
  }
  render() {
    const { styles: styles2 } = this;
    const disabledClass = this.props.disabled ? "Dropdown-disabled" : "";
    const selected = this.state.selected;
    const placeHolderValue = typeof selected === "string" ? selected : (() => {
      const label = (selected == null ? void 0 : selected.label) || "";
      const Icon = (selected == null ? void 0 : selected.icon) || null;
      const OptionComponent = (selected == null ? void 0 : selected.component) || null;
      return /* @__PURE__ */ React.createElement("span", null, Icon ? /* @__PURE__ */ React.createElement(Icon, { className: styles2["Dropdown-option-icon"] }) : null, label && /* @__PURE__ */ React.createElement("span", { className: styles2["Dropdown-option-label"] }, label), OptionComponent && /* @__PURE__ */ React.createElement(OptionComponent, null));
    })();
    const value = /* @__PURE__ */ React.createElement("div", { className: styles2["Dropdown-placeholder"], role: "textbox" }, placeHolderValue);
    const menu = this.state.isOpen ? /* @__PURE__ */ React.createElement("div", { className: classNames(styles2["Dropdown-menu"], this.props.menuClassName), role: "listbox" }, this.buildMenu()) : null;
    const dropdownClass = classNames(this.styles["Dropdown-root"], {
      [this.styles["Dropdown-root-isOpen"]]: this.state.isOpen
    });
    const { dataHook, tabIndex } = this.props;
    return tabIndex !== void 0 && tabIndex > -1 && /* @__PURE__ */ React.createElement("div", { className: dropdownClass }, /* @__PURE__ */ React.createElement(
      "button",
      {
        role: "combobox",
        "aria-controls": isSSR() ? void 0 : `${this.id}_menu`,
        "aria-expanded": this.state.isOpen,
        className: classNames(
          this.styles["Dropdown-control"],
          this.props.controlClassName,
          disabledClass
        ),
        "data-hook": dataHook,
        onClick: this.handleMouseDown,
        onTouchEnd: this.handleMouseDown
      },
      value,
      /* @__PURE__ */ React.createElement(
        "span",
        {
          className: classNames(this.styles["Dropdown-arrow"], {
            [this.styles["Dropdown-arrow-isOpen"]]: this.state.isOpen
          })
        },
        /* @__PURE__ */ React.createElement(DropdownArrowIcon, null)
      )
    ), menu);
  }
}

export { Dropdown as default };
//# sourceMappingURL=Dropdown.js.map
